import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { CalculationStatisticClusterType } from '@ydistri/api-sdk';
import { ClusterTypeValueType, setClusterType } from '../evaluationSlice';
import { ReduxState, useAppDispatch } from '../../../../store';
import { useApplicationData } from '../../../../hooks/useApplicationData';

/**
 * Data is clustered by StoreDepartment only when departments are used in the current project.
 * If they are, they should be the default cluster type.
 * This hook ensures that the cluster type is set accordingly and indicates when it's ready to be used.
 */
export const useClusterTypeReady = (): boolean => {
  const dispatch = useAppDispatch();
  const { departments: hasDepartments, isLoading } = useApplicationData();
  const clusterTypeValueType = useSelector(
    (state: ReduxState) => state.evaluations.clusterTypeValueType,
  );

  // Side-effect only: initialize the cluster type when departments are present
  useEffect(() => {
    if (!isLoading && hasDepartments && clusterTypeValueType === ClusterTypeValueType.INITIAL) {
      dispatch(setClusterType(CalculationStatisticClusterType.StoreDepartment));
    }
  }, [clusterTypeValueType, dispatch, hasDepartments, isLoading]);

  // Derived value — no local state required
  if (isLoading) return false;
  if (!hasDepartments) return true;
  return clusterTypeValueType === ClusterTypeValueType.UPDATED;
};
